// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import ProductProxy from "@/proxies/ProductProxy"

const state = {
  products: [],
  product: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new ProductProxy(params).all()
    commit("SET_PRODUCTS", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new ProductProxy(params).find(id)
    commit("SET_PRODUCT", response)
  },

  async create(_, item) {
    return await new ProductProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new ProductProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new ProductProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
